import { SSR_TEST_QUERY_FIRED } from '@confluence/graphql/entry-points/SSRTestLink.ts';
import { getQueryBoundary } from '@confluence/query-preloader-boundary/entry-points/queryBoundaryStorage.ts';

// Keep query listeners at loading state when GLOBAL_APOLLO_SKIP_QUERY is true.
// SSR runtime will cancel all the in-flight requests once the main function exits.

const logBlockedQuery = (operationName: string, reason: string) => {
	if (
		process.env.CLOUD_ENV === 'dev' ||
		process.env.CLOUD_ENV === 'branch' ||
		process.env.CLOUD_ENV === 'staging' ||
		process.env.CLOUD_ENV === 'hello'
	) {
		// eslint-disable-next-line no-console
		console.warn(`Query blocked: ${operationName}. Reason: ${reason}`);
	}
};

export const shouldBlockRequest = ({
	operationName,
	operationKind,
}: {
	operationName: string;
	operationKind?: string;
}): boolean => {
	if (!window['GLOBAL_APOLLO_SKIP_QUERY']) {
		return false;
	}

	// experimental is not being used for Relay

	if (operationKind === 'subscription') {
		logBlockedQuery(operationName, 'Subscription');
		return true;
	}

	// Allow the query only if it is fired within a boundary (preloader).
	if (getQueryBoundary()) {
		return false;
	}

	logBlockedQuery(
		operationName,
		'No query boundary. Query fired outside preloaders after rendering started.',
	);
	return true;
};

export const markSSRTestQueryFired = (operationName: string): void => {
	SSR_TEST_QUERY_FIRED[operationName] = (SSR_TEST_QUERY_FIRED[operationName] || 0) + 1;
};
